<template>
  <div v-bind:class="{loading: isLoading}" id="buy-browse" class="columns">
    <div class="column is-3">
      <h2 class="subtitle">Browse</h2>
      <aside class="menu">
        <ul class="menu-list">
          <li v-for="s in sets">
            <router-link v-bind:class="{'is-active': $route.params.id === s.uuid}" :to="{name: 'ViewCategory', params: { id: s.uuid}}">{{ s.name }}</router-link>
          </li>
        </ul>
      </aside>
    </div>
    <div class="column">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Client from 'shopify-buy';
import Raven from 'raven-js';

export default {
  name: 'buybrowse',
  data() {
    return {
      isLoading: false,
      sets: [],
    };
  },
  mounted() {
    this.isLoading = true;

    this.client = Client.buildClient({
      storefrontAccessToken: 'c532a34d42a102560faf84bbb93624f1',
      domain: 'powernine.myshopify.com',
      appId: '6',
    });

    new Promise((resolve) => {
      if (localStorage.getItem('shopifyCheckoutId')) {
        resolve(this.client.checkout.fetch(localStorage.getItem('shopifyCheckoutId')));
      }

      resolve(null);
    }).then((checkout) => {
      if (!checkout) {
        return this.client.checkout.create();
      }

      return checkout;
    }).then((checkout) => {
      localStorage.setItem('shopifyCheckoutId', checkout.id);
    })
    .then(() => this.axios.get('https://inventory.powernine.com/shopify/sets'))
    .then((response) => {
      this.sets = response.data;
      this.isLoading = false;
    })
    .catch((err) => {
      this.isLoading = false;
      Raven.captureException(err);
      throw err;
    });
  },
};
</script>



// WEBPACK FOOTER //
// BuyBrowse.vue?6ba1c19d